<template>
  <div :class="$style.frameGroup">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
        <div :class="$style.formGroup">
          <div>Company Name</div>
          <input type="text" v-model="form.name" placeholder="Name..." />
        </div>
        <div :class="$style.formGroup">
          <div>Business Type</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.businessTypeId"
            :options="businessTypesList"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>
      </div>

      <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
        <div :class="$style.formGroup">
          <div>Email</div>
          <input type="email" v-model="form.email" placeholder="Email..." />
        </div>
        <div :class="$style.formGroup">
          <div>Phone</div>
          <input
            type="text"
            v-model="form.phone"
            placeholder="Phone Number..."
          />
        </div>
      </div>

      <div :class="$style.formGroup">
        <div>Website URL</div>
        <input
          type="text"
          v-model="form.url"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the business address?</div>
        <div :class="$style.formGroup">
          <input
            type="text"
            v-model="form.address1"
            placeholder="Street Address..."
          />
        </div>
      </div>
      <div :class="$style.flexGroupAddress" :style="$global.dynamicCols(2)">
        <div :class="$style.formGroup">
          <input
            type="text"
            v-model="form.address2"
            placeholder="Apt. or Suite..."
          />
        </div>
        <div :class="$style.formGroup">
          <input type="text" v-model="form.city" placeholder="City..." />
        </div>
      </div>
      <div :class="$style.flexGroupAddress" :style="$global.dynamicCols(3)">
        <div :class="$style.formGroup">
          <input type="text" v-model="form.state" placeholder="State..." />
        </div>
        <div :class="$style.formGroup">
          <input type="text" v-model="form.zip" placeholder="Zip..." />
        </div>
        <div :class="$style.formGroup">
          <input type="text" v-model="form.country" placeholder="Country..." />
        </div>
      </div>

      <div :class="$style.briefLabel">Brief Company Description</div>
      <div :class="$style.formGroupTextArea">
        <textarea
          v-model="form.description"
          maxlength="120"
          :class="$style.textarea"
          rows="2"
          placeholder="Brief description about your company..."
        ></textarea>
        <div :class="$style.charactersMax">(120 Characters Max)</div>
      </div>

      <div :class="$style.formGroup">
        <div>Loan products offered?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.loanProducts"
          multi-select
          :options="loanProductsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Target Market or Industries Served</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.targetMarkets"
          multi-select
          :options="targetMarketsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you specialize in aviation financing?</div>
        <HiloSelect
          id="aviationFinancing"
          :theme="'grey'"
          v-model="form.aviationFinancing"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Loan Terms Offered</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.loanTerms"
          multi-select
          :options="loanTermsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you provide pre-approval services?</div>
        <HiloSelect
          id="preApprovalServices"
          :theme="'grey'"
          v-model="form.preApprovalServices"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the minimum loan amount you offer?</div>
        <input
          type="number"
          v-model="form.minLoanAmount"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the maximum loan amount you offer?</div>
        <input
          type="number"
          v-model="form.maxLoanAmount"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you offer deferred payment options?</div>
        <HiloSelect
          id="deferredPaymentOptions"
          :theme="'grey'"
          v-model="form.deferredPaymentOptions"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          Do you provide financial counseling or advisory services to borrowers?
        </div>
        <HiloSelect
          id="financialCounseling"
          :theme="'grey'"
          v-model="form.financialCounseling"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What documentation is required for loan applications?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.requiredDocumentations"
          multi-select
          :options="requiredDocumentationsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          Are you interested in partnering with flight schools for exclusive
          financing programs?
        </div>
        <HiloSelect
          id="flightSchoolPartnership"
          :theme="'grey'"
          v-model="form.flightSchoolPartnership"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Geographical Reach</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.geographicalReaches"
          multi-select
          :options="geographicalReachesList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b :class="$style.name">Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b :class="$style.name">Back</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
import get from "lodash/get";
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    lenderId: {
      type: Number,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        name: "",
        businessTypeId: "",
        email: "",
        phone: "",
        url: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        description: "",
        loanProducts: [],
        targetMarkets: [],
        aviationFinancing: "",
        loanTerms: [],
        preApprovalServices: "",
        minLoanAmount: "",
        maxLoanAmount: "",
        deferredPaymentOptions: "",
        financialCounseling: "",
        requiredDocumentations: [],
        flightSchoolPartnership: "",
        geographicalReaches: [],
      },
      businessTypesList: [],
      loanProductsList: [],
      targetMarketsList: [],
      loanTermsList: [],
      requiredDocumentationsList: [],
      geographicalReachesList: [],
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getAboutYouLists();
      await this.getAboutYouSavedData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.businessTypesList,
          this.loanProductsList,
          this.targetMarketsList,
          this.loanTermsList,
          this.requiredDocumentationsList,
          this.geographicalReachesList,
        ] = await Promise.all([
          aboutYouAPIService.getBusinessTypesList(),
          aboutYouAPIService.getLoanProductsList(),
          aboutYouAPIService.getTargetMarketsList(),
          aboutYouAPIService.getLoanTermsList(),
          aboutYouAPIService.getRequiredDocumentationsList(),
          aboutYouAPIService.getGeographicalReachesList(),
        ]);
        this.requiredDocumentationsList =
          this.requiredDocumentationsList.filter((rd) => rd.lender);
      } catch (error) {}
    },
    async getAboutYouSavedData() {
      if (this.lenderId) {
        try {
          const fetchedData = await aboutYouAPIService.getLenderById(
            this.lenderId,
          );
          if (fetchedData) {
            this.form = { ...this.form, ...fetchedData };
          }
        } catch (error) {}
      }
    },
    async handleNext() {
      let isValid = true;
      const validations = [
        { field: "name", desc: "company name" },
        { field: "businessTypeId", desc: "business type" },
        { field: "email", desc: "email" },
        { field: "phone", desc: "phone number" },
        { field: "url", desc: "website URL" },
        { field: "address1", desc: "street address" },
        { field: "city", desc: "city" },
        { field: "state", desc: "state" },
        { field: "zip", desc: "ZIP Code" },
        { field: "country", desc: "country" },
        { field: "description", desc: "brief company description" },
        { field: "loanProducts", desc: "loan products offered" },
        { field: "targetMarkets", desc: "target market or industries served" },
        { field: "aviationFinancing", desc: "aviation financing" },
        { field: "loanTerms", desc: "loan terms offered" },
        { field: "deferredPaymentOptions", desc: "deferred payment options" },
        { field: "preApprovalServices", desc: "pre-approval services" },
        { field: "minLoanAmount", desc: "min loan amount" },
        { field: "maxLoanAmount", desc: "max loan amount" },
        { field: "financialCounseling", desc: "financial counseling services" },
        { field: "requiredDocumentations", desc: "required documentation" },
        { field: "flightSchoolPartnership", desc: "flight school partnership" },
        { field: "geographicalReaches", desc: "geographical reach" },
      ];

      for (const { field, desc } of validations) {
        const fieldValue = get(this.form, field);

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          isValid = false;
          alert(`Please enter a ${desc}`);
          break;
        }
      }

      if (!isValid) return;

      if (this.form.minLoanAmount > this.form.maxLoanAmount) {
        alert(
          "Minimum loan amount cannot be more than the maximum loan amount.",
        );
        return;
      }

      try {
        this.loading = true;
        const aboutYouData = {
          ...this.form,
          lenderId: this.lenderId,
          userId: this.userId,
        };
        const lender =
          await aboutYouAPIService.createOrUpdateLender(aboutYouData);
        if (!this.lenderId) {
          this.$emit("setLenderId", lender.id);
        }
        this.$emit("onNext", { aboutYou: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.flexGroupAddress {
  display: grid;
  gap: 10px;
  margin-top: -15px;
}

.formGroupTextArea {
  width: 100%;
  position: relative;
  border-radius: 10px;
  background-color: #f5f5f5;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
  margin-top: -15px;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.briefLabel {
  font-size: 15px;
}

.textarea {
  width: 100%;
  border: none;
  border-radius: 5px;
  resize: none;
  font-size: 15px;
  color: #404040;
  background-color: transparent;
}

.charactersMax {
  align-self: stretch;
  position: relative;
  font-size: 12px;
  text-align: right;
  color: rgba(64, 64, 64, 0.7);
}
</style>
